// Shared item-export column choices (tenant/retailer aware) used by the export modals.
export function buildExportColumns (tenant, isRetailer) {
  return [
    { id: 'source', label: 'Source', order: 1, show: true },
    { id: 'item_id', label: 'Item Id', order: 2, show: true },
    { id: 'description', label: 'Item Description', order: 3, show: true },
    { id: 'upc', label: 'Item UPC', order: 4, show: true },
    { id: 'vendor_id', label: 'Vendor Id', order: 5, show: !isRetailer },
    { id: 'vendor_name', label: 'Vendor Name', order: 6, show: !isRetailer },
    { id: 'department', label: 'Department', order: 7, show: true },
    { id: 'category', label: 'Category', order: 8, show: true },
    { id: 'subcategory', label: 'SubCategory', order: 9, show: true },
    { id: 'qty_per_case', label: 'Qty Per Case', order: 10, show: true },
    { id: 'weight', label: 'Weight', order: 11, show: tenant === 'jbg' },
    { id: 'cube', label: 'Cube', order: 12, show: tenant === 'jbg' },
    { id: 'weekly_avg_case_mvmt', label: 'Weekly Avg Case Mvmt', order: 13, show: tenant === 'jbg' },
    { id: 'on_hand_qty', label: 'On Hand', order: 14, show: tenant === 'jbg' },
    { id: 'pack_size', label: 'Pack Size', order: 15, show: true },
    { id: 'status', label: 'Status', order: 16, show: tenant === 'jbg' }
  ].filter(d => d.show)
}



// WEBPACK FOOTER //
// ./src/components/items/data/exportColumns.js